/** Super plataforma ou empresa marcada como parceira (menus Empresas / Planos / etc.) */
export const hasResellerAccess = (user) =>
  !!user?.super || !!user?.company?.isPartner;
